module.exports = __webpack_public_path__ + "img/icon-electricity.4aac5a76.svg";